import styled from 'styled-components';
import {
  ToastContainer,
} from 'react-toastify';

import {
  icons,
} from 'web-styled';

export const ToastifyContainer = styled(ToastContainer).attrs({
  position: 'bottom-right',
  autoClose: 5000,
  draggable: false,
  newestOnTop: true,
  hideProgressBar: true,
})`
  --toastify-z-index: 99999;
  --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: ${props => props.theme.colors.primary};
  --toastify-color-success: ${props => props.theme.colors.success};
  --toastify-color-warning: ${props => props.theme.colors.warning};
  --toastify-color-error: ${props => props.theme.colors.danger};
  --toastify-color-transparent: rgba(255, 255, 255, .7);
  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);

  --toastify-toast-padding: 10px;
  --toastify-toast-min-height: 64px;
  --toastify-toast-max-height: 800px;

  .Toastify__toast {
    position: relative;
    margin-bottom: 1rem;
    border-radius: 3px;
    border-left-width: 5px;
    border-left-style: solid;
    padding-left: 0;
    font-size: 15px;
    font-family: 'Source Sans Pro', sans-serif;

    .Toastify__toast-icon {
      display: none
    }

    &:before,
    &:after {
      content: '';
      display: inline-block;
      flex-shrink: 0;
    }

    &:before {
      width: 25px;
      height: 25px;
      border-radius: 25px;
      margin: 8px 12px;
    }

    &:after {
      width: 18px;
      height: 18px;
      position: absolute;
      left: 16px;
      top: 20px;
    }

    &--default {
      border-color: #808080;
      &:before {
        background: #808080 url(${icons.exercises});
        background-size: cover;
      }
    }

    &--info {
      border-color: var(--toastify-color-info);
      &:before {
        background: ${props => props.theme.colors.primary} url(${icons.warningIcon}) no-repeat center;
        background-size: 11px;
      }
    }

    &--warning {
      border-color: var(--toastify-color-warning);
      &:before {
        background: ${props => props.theme.colors.warning} url(${icons.warningIcon}) no-repeat center;
        background-size: 11px;
      }
    }

    &--success {
      border-color: var(--toastify-color-success);
      &:before {
        background: ${props => props.theme.colors.success} url(${icons.exercises});
        background-size: cover;
      }
    }

    &--error {
      border-color: var(--toastify-color-error);
      &:before {
        content: 'x';
        color: #fff;
        font-size: 15px;
        text-align: center;
        background: ${props => props.theme.colors.danger};
      }
    }

    &--with-custom-component {
      border: none;
      border-radius: 10px;
      padding: 20px;
      background-color: #EBF6FF;
      box-shadow: 0px 4px 4px 0px #00000040;


      h3 {
        margin-top: 0;
      }

      &:before {
        display: none;
      }

      .Toastify__close-button--light {
        top: 22px;
        right: 12px;
      }
    }
  }
`;
